import React, {FC} from 'react';

import {SettingsDevelopersTokensUrl} from '../../../../models/url/settingsUrlModel';
import {SettingsPanelId} from '../../../../store/panels/panelStateBase';
import {DevelopersApiTokensTableContainer} from '../../tables/apiTokens/developersApiTokensTableContainer';
import {SettingsDevelopersApiTokenPageContainer} from './settingsDevelopersApiTokenPageContainer';

/*
 * Props.
 */

interface SettingsDevelopersApiTokensPageProps {
  panelId: SettingsPanelId;
  url: SettingsDevelopersTokensUrl;
}

/*
 * Component.
 */

export const SettingsDevelopersApiTokensPage: FC<SettingsDevelopersApiTokensPageProps> = (props) => {
  const {panelId, url} = props;
  if (url.tokenId) {
    return <SettingsDevelopersApiTokenPageContainer panelId={panelId} tokenId={url.tokenId} />;
  }
  return <DevelopersApiTokensTableContainer panelId={panelId} />;
};
